var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPointSale(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 92,
    viewBox: "0 0 78 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_490_2598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.19 10.7681C69.5556 17.5169 73.1963 26.6263 73.3423 36.1699C73.4882 45.7135 70.128 54.9432 63.9721 61.9073L63.19 62.7652L46.8439 80.0934C44.7698 82.2912 41.9854 83.571 39.0547 83.6734C36.124 83.7758 33.2662 82.6932 31.0602 80.6449L30.5054 80.0934L14.1554 62.7611C7.65301 55.8664 4 46.5152 4 36.7646C4 27.014 7.65301 17.6628 14.1554 10.7681C20.6578 3.8734 29.4769 0 38.6727 0C47.8685 0 56.6876 3.8734 63.19 10.7681ZM38.6727 24.5098C37.155 24.5098 35.6521 24.8268 34.2499 25.4426C32.8476 26.0585 31.5735 26.9612 30.5003 28.0991C29.4271 29.2371 28.5758 30.5881 27.995 32.0749C27.4142 33.5617 27.1152 35.1553 27.1152 36.7646C27.1152 38.3739 27.4142 39.9675 27.995 41.4543C28.5758 42.9411 29.4271 44.2921 30.5003 45.43C31.5735 46.568 32.8476 47.4707 34.2499 48.0865C35.6521 48.7024 37.155 49.0194 38.6727 49.0194C41.738 49.0194 44.6777 47.7282 46.8451 45.43C49.0126 43.1318 50.2302 40.0148 50.2302 36.7646C50.2302 33.5144 49.0126 30.3974 46.8451 28.0991C44.6777 25.8009 41.738 24.5098 38.6727 24.5098Z",
    fill: "#F5B658"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_490_2598",
    x: 0,
    y: 0,
    width: 77.3467,
    height: 91.6797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_490_2598"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_490_2598",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointSale);
export default __webpack_public_path__ + "static/media/pointSale.895b967d9b13d13fccd982a46d9d45a7.svg";
export { ForwardRef as ReactComponent };